export default function EmptyPage() {
  return  <h1 
            style={{ 
              textAlign: "center",
              marginTop: "50px" }}
          >
          TBD -> Under Construction
          </h1>;
}
